import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import { type MapRectangleArea } from './types/index.js';

/**
 * 传输时间热区位置点, 到Native, 当前热区只支持矩形, 坐标原点为左上角定点.
 */
export type FabricMapSetHotRegionOptions = {
  /**
   * 一次可以传递多个热区点矩形
   */
  regions: Array<MapRectangleArea>;
};

export type FabricMapSetHotRegionApi = (
  options: FabricMapSetHotRegionOptions
) => Promise<boolean>;

/**
 * 更新打车热区位置点列表
 */
export const setHotRegion: FabricMapSetHotRegionApi = (
  options: FabricMapSetHotRegionOptions
): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<'fabric_map.setHotRegion', FabricMapSetHotRegionOptions, boolean>(
      'fabric_map.setHotRegion',
      options,
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
